// 基座插件化配置
import Axios, { get, post, put, patch, del } from '@/utils/http.js'

export default {
  name: 'dolphinEngine',
  // eslint-disable-next-line
  install(Vue, options = {}) {
    Vue.prototype.$http = { get, post, put, patch, del }
    Vue.prototype.$axios = Axios
  },
}
